import de from '@translations/de/finishRegistrationForm.json';
import en from '@translations/en/finishRegistrationForm.json';
import pl from '@translations/pl/finishRegistrationForm.json';
import sl from '@translations/sl/finishRegistrationForm.json';
import uk from '@translations/uk/finishRegistrationForm.json';
import bg from '@translations/bg/finishRegistrationForm.json';
import cz from '@translations/cz/finishRegistrationForm.json';
import fr from '@translations/fr/finishRegistrationForm.json';
import gr from '@translations/gr/finishRegistrationForm.json';
import it from '@translations/it/finishRegistrationForm.json';
import pr from '@translations/pr/finishRegistrationForm.json';
import ru from '@translations/ru/finishRegistrationForm.json';
import sk from '@translations/sk/finishRegistrationForm.json';
import sp from '@translations/sp/finishRegistrationForm.json';
import tr from '@translations/tr/finishRegistrationForm.json';
import hu from '@translations/hu/finishRegistrationForm.json';
import { ITranslations } from '@/types/common';
import { FinishRegistrationFormTransFields } from './types';

export const finishRegistrationFormTranslations: ITranslations<FinishRegistrationFormTransFields> =
  {
    name: 'finishRegistrationForm',
    de,
    en,
    pl,
    sl,
    uk,
    bg,
    cz,
    fr,
    gr,
    it,
    pr,
    ru,
    sk,
    sp,
    tr,
    hu,
  };
